"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIframe = void 0;
const constants_1 = require("./constants");
const getIframe = () => {
    const nfidIframe = document.getElementById(constants_1.IFRAME_ID);
    if (!nfidIframe || !nfidIframe.contentWindow) {
        throw new Error('nfid iframe not initialized');
    }
    return nfidIframe;
};
exports.getIframe = getIframe;
